// @flow
import React, { Component } from 'react';
import styled from 'styled-components';

import LeagueAvatar from '../../../components/Leagues/LeagueAvatar';
import LeagueName from '../../../components/Leagues/LeagueName';
import LeagueTypeLabel from '../../../components/Leagues/LeagueTypeLabel';

import colors from '../../../assets/css/colors';
import { below, above } from '../../../assets/css/media';

const LeagueNameStyled = styled(LeagueName)`
	flex: 1 1 100%;
	width: 100px;

	@media screen and (min-width: 480px) {
		flex: 1 1 60%;
		width: 180px;
	}
`;

const Container = styled.div`
    position: relative;
    z-index: 1;

	display: flex;
	align-items: center;
	height: 60px;

	background: ${({ background }) => background ? background : '#ffffff'};
	box-shadow: 0 0 5px 0 rgba(0,0,0,0.15);
`;

const OuterContainer = styled.div`
	margin-bottom: 10px;

	${above.phone`
		margin-bottom: 20px;
	`}
`;

const LeagueAvatarContainer = styled.div`
	width: 40px;
	height: 40px;
	margin-left: 10px;
	margin-right: 10px;
	flex: 0 0 40px;
`;

const TeamCountLabel = styled.div`
	font-size: 10px;
	line-height: 1.4;
	letter-spacing: 0.5px;
	text-transform: uppercase;
	color: ${colors.title};
	margin-bottom: 5px;
`;

const TeamCountNumbers = styled.div`
	font-size: 14px;
	font-weight: bold;
	color: ${colors.title};
	line-height: 1.14;
`;

const TeamCountWrapper = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	margin-right: 10%;

	${above.tablet`
		margin-right: 20%;
	`}

	${below.phone`
		display: none;
	`}
`;

const RightSection = styled.div`
	display: flex;
	align-items: center;
	padding-right: 5px;
	flex: 0 1 100%;
	justify-content: flex-end;

	@media screen and (min-width: 480px) {
		padding-right: 20px;
	}
`;

type Props = {
	league: Object,
	renderRightSide: Function,
	renderBelow?: Function,
	is_commissioner?: boolean,
	show_teams_count?: boolean,
	background?: string,
	is_live_draft?: boolean
};

class LeagueBase extends Component<Props> {
	renderLeftSection = () => {
		const {
			league,
			is_commissioner,
			show_teams_count,
			is_live_draft
		} = this.props;

		const leagueCommissionerProps = is_commissioner ?
			{ commissioner: "You are the Commissioner" } :
			{
				firstname: league.firstname || league.first_name,
				lastname: league.lastname || league.last_name
			};

		return (
			<React.Fragment>
				<LeagueTypeLabel
					rotate="-90"
					text={league.privacy ? 'PUBLIC' : 'PRIVATE'}
					background_color={is_live_draft ? colors.liveGreen : null}
				/>
				<LeagueAvatarContainer>
					<LeagueAvatar league={league} />
				</LeagueAvatarContainer>
				<LeagueNameStyled
					name={league.name}
					{...leagueCommissionerProps}
				/>

				{show_teams_count && (
					<TeamCountWrapper>
						<TeamCountLabel>Teams</TeamCountLabel>
						<TeamCountNumbers>{`${league.num_teams}/${league.size}`}</TeamCountNumbers>
					</TeamCountWrapper>
				)}
			</React.Fragment>
		);
	}

	render() {
		const {
			renderRightSide,
			renderBelow,
			background,
		} = this.props;

		return (
			<OuterContainer>
				<Container background={background}>
					{this.renderLeftSection()}
					<RightSection>
						{renderRightSide()}
					</RightSection>
				</Container>
				{renderBelow && renderBelow()}
			</OuterContainer>
		);
	}
}

export default LeagueBase;


// WEBPACK FOOTER //
// ./src/pages/leagues/myLeagues/LeagueBase.js